<template>
  <div>
    <ejs-button :disabled='disabled' :cssClass='cssClass' v-on:click.native="downloadResult">{{this.$ts('MCS.downloadResult')}}</ejs-button>
  </div>
</template>

<script>
  import i18n from "../../../../plugins/i18n";

  export default {
    name: 'DownloadChain',
    data() {
      return {
        disabled: true,
        cssClass: ''
      };
    },
    methods: {
      $ts(args) {
        const mes = args.split('.');
        const result = (mes[0] && mes[1] && i18n.messages[i18n.locale][mes[0]][mes[1]]) ? i18n.messages[i18n.locale][mes[0]][mes[1]] : args;
        return result;
      },
      downloadButtonInit(){
        const taskStatus = this.$data.data.taskStatus;
        if(taskStatus == 0){
          this.disabled = false;
          this.cssClass = 'e-primary';
        }else{
          this.disabled = true;
          this.cssClass = '';
        }
      },
      downloadResult() {
        const taskId = this.$data.data.taskId;
        const detailId = this.$data.data.detailId;
        const params = {
        }
        const config = {
          responseType: 'blob'
        };
        this.$loading.showLoadding(this.$ts('Software.downloading'));
        this.$axios.post(`/lte/ems/subscriber/mcs/batch/resultDownload.html?detailId=${detailId}&taskId=${taskId}`, params, config).then((res) => {
          const link = document.createElement('a');
          const blob = new Blob([res.data], { type: 'application/zip' });
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          const fileName = 'result.zip';
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.$loading.hideLoadding();
        });
      }
    },
    mounted() {
      this.downloadButtonInit();
    }
  };
</script>
